// extracted by mini-css-extract-plugin
module.exports = {"button":"Popper_button__KWlPD"};